<template>
  <div class="main-content">
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <div v-show="isEdit||(readonly&&!job.lclMasterUuid)">
          <el-button
            v-show="isEdit"
            no="changeSealHandler"
            type="primary"
            :disabled="selectedContainerUsage === null"
            @click="changeSealHandler"
          >{{ $t('SeaExport.SealNoChangeAdfterInspection') }}</el-button>
          <el-button
            v-show="isEdit"
            no="AutoAllocation"
            type="primary"
            @click="autoLoadHandler"
          >{{ $t('SeaExport.AutoAllocation') }}</el-button>
          <el-button
            v-show="isEdit"
            no="CleanOutTheLoadingRecord"
            type="primary"
            :disabled="selectedContainerUsage === null"
            @click="autoUnloadHandler"
          >{{ $t('SeaExport.CleanOutTheLoadingRecord') }}</el-button>
          <el-button
            v-show="isEdit&&!job.lclMasterUuid"
            no="DeleteTheLoadingRecord"
            type="primary"
            :disabled="selectedContainerUsage === null"
            @click="deleteContainerHandler"
          >{{ $t('SeaExport.DeleteTheLoadingRecord') }}</el-button>
          <el-button
            v-show="isEdit&&isFCL"
            no="TemplateDownload"
            type="primary"
            @click="downTemplateBtn_clickHandler"
          >{{ $t('SeaExport.TemplateDownload') }}</el-button>
          <el-upload
            v-show="isEdit&&isFCL"
            no="ExcelImport"
            action="string"
            :http-request="importExcelEventHandler"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :before-upload="beforeUploadUsage"
            style="display: inline-block;margin-left: 5px;"
          >
            <el-button type="primary">{{ $t('SeaExport.ExcelImport') }}</el-button>
          </el-upload>
          <el-button
            v-show="readonly&&!job.lclMasterUuid&&viewSource!='salesDetail'"
            no="CallContainer"
            type="primary"
            @click="callContainerEvent"
          >{{ $t('RailwayExport.CallContainer') }}</el-button>
          <el-button
            v-show="readonly&&!job.lclMasterUuid&&viewSource!='salesDetail'"
            no="BuyContainer"
            type="primary"
            @click="buyContainerEvent"
          >{{ $t('RailwayExport.BuyContainer') }}</el-button>
          <el-button
            v-show="readonly&&!job.lclMasterUuid&&viewSource!='salesDetail'"
            no="RentContainer"
            type="primary"
            @click="rentContainerEvent"
          >{{ $t('RailwayExport.RentContainer') }}</el-button>
          <el-button
            v-show="readonly&&!job.lclMasterUuid&&viewSource!='salesDetail'"
            no="ClearContainerLog"
            type="primary"
            @click="clearContainerEvent"
          >{{ $t('RailwayExport.ClearContainerLog') }}</el-button>
          <el-button
            v-show="readonly&&!job.lclMasterUuid&&viewSource!='salesDetail'"
            no="ReturnBox"
            type="primary"
            @click="returnBoxEvent"
          >{{ $t('RailwayExport.ReturnBox') }}</el-button>
        </div>
        <div>
          <span>
            {{ $t('SeaExport.CargoQuantityDescription') }}：{{ lbTotalDesc.lblContainerDesc }}&nbsp;&nbsp;&nbsp;
            {{ $t('SeaExport.TotalNumberOfPackages') }}：{{ lbTotalDesc.lbTotalQuantity }}&nbsp;&nbsp;&nbsp;
            {{ $t('SeaExport.TotalWeight') }}：{{ lbTotalDesc.lbTotalWeight }}&nbsp;&nbsp;&nbsp;
            {{ $t('SeaExport.TotalCubage') }}：{{ lbTotalDesc.lbTotalCubage }}&nbsp;&nbsp;&nbsp;
            <el-button
              v-show="btnshowAWindow && !isEdit"
              no="ViewAssociatedBusiness"
              type="primary"
              @click="showAWindowClickHandler"
            >{{ $t('SeaExport.ViewAssociatedBusiness') }}</el-button>
          </span>
        </div>
      </div>
    </div>
    <div class="section" style="flex: 1">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="containerUsages || []"
        style="width: 100%;height: 100%"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <!-- 查验更改封号弹窗 -->
    <seal-number-change-dialog
      :visible.sync="boxNoDialog.visible"
      :prop-form-data="selectedContainerUsage"
      @sealCloseHandler="sealCloseHandler"
    />
    <!-- 查看关联业务 -->
    <associated-business-dialog
      :visible.sync="associatedBusinessDialog.visible"
      :a-data="associatedBusinessDialog.aData"
      :job="job"
      @refresh="refresh"
    />
    <!-- 调箱弹窗 -->
    <call-container-dialog
      :visible.sync="callContainerDialog.visible"
      :job="job"
      @successCallback="reload"
    />
    <!-- 买箱弹窗 -->
    <box-operation-dialog
      :visible.sync="boxOperationDialog.visible"
      :job="job"
      :title="boxOperationDialog.title"
      :order-type="boxOperationDialog.orderType"
    />
    <!-- 还箱弹窗 -->
    <return-box-dialog
      :visible.sync="returnBoxDialog.visible"
      :job="job"
      :select-list="returnBoxDialog.selectList"
      @successCallback="reload"
    />
  </div>
</template>

<script>
import SealNumberChangeDialog from '@/components/Cargo/Job/sealNumberChangeDialog'
import AssociatedBusinessDialog from '@/components/Cargo/Job/associatedBusinessDialog'
import callContainerDialog from '../callContainerDialog'
import boxOperationDialog from '../boxOperationDialog'
import returnBoxDialog from '../returnBoxDialog'
import lodash from 'lodash'
import { formatNumberToThousands } from '@/utils'
import { TabError } from '@/utils/class/TabError'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as NumberUtils from '@/utils/NumberUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import ContainerNoHelper from '@/utils/containerNoHelper'
import { isNumber } from '@/utils/validate'
import { roundHalfUp } from '@/utils/NumberUtils'
import StrUtils from '@/utils/StrUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as EQSize from '@/class/cargo/model/parameters/EQSize'
import * as BoxTubeConstants from '@/class/cargo/model/parameters/BoxTubeConstants'
import { DataPushCompareUtils } from '@/class/cargo/model/utils/DataPushCompareUtils'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { Job } from '@/class/model/booking/Job'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import { queryAssociatedBusiness } from '@/api/seaExport/containerUsage'
import { importExcelData } from '@/api/seaExport/containerUsage'
import { clearContainer } from '@/api/railwayExport/railwayContainer'
import { getLoading } from '@/utils/utilBaseElement'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import CargoAgGridDateTimeEditor from '@/components/Cargo/Common/CargoAgGridDateTimeEditor'
export default {
  name: 'ReTabContainer',
  components: { SealNumberChangeDialog, AssociatedBusinessDialog, callContainerDialog, boxOperationDialog, returnBoxDialog },
  props: {
    context: { type: Object, required: true },
    action: { type: String, required: true },
    viewSource: { type: String, default: '' }, // 页面请求发起方
    cooperateEdit: { type: Boolean, default: true } // 能否修改
  },
  data() {
    return {
      isTabBasic: true, // CARGO-7908 (cargo 中在bookingworkspace 中设置的是true)
      job: new Job().fillDefaultValue().getData(),
      isFCL: false, //  是否为整箱
      lbTotalDesc: { // 货物描述
        lblContainerDesc: '',
        lbTotalQuantity: '',
        lbTotalWeight: '',
        lbTotalCubage: ''
      },
      btnshowAWindow: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        frameworkComponents: { // 添加编辑组件
          CargoAgGridDateTimeEditor
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onCellFocused(event)
        },
        context: {
          componentParent: this
        },
        onRowClicked: this.itemClickHandler
      },
      containerUsages: [], // 装箱列表数据List
      gridApi: null,
      dgContainerEditable: false, // 列表是否允许编辑
      selectedContainerUsage: null,
      boxNoDialog: {
        visible: false
      },
      associatedBusinessDialog: {
        visible: false,
        aData: {}
      },
      callContainerDialog: {
        visible: false
      },
      boxOperationDialog: {
        visible: false,
        title: '',
        orderType: 0
      },
      returnBoxDialog: {
        visible: false,
        selectList: []
      },
      relatedRailwayContainers: false,
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    columnDefs() {
      const columnDefs = [
        {
          headerName: '',
          colId: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.ContainerSize'),
          colId: 'eqSize',
          field: 'eqSize',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: false,
            tag: 'span',
            attrs: {
              classFunc: (params) => {
                return ContainerUtil.containerPushDataStyleFunction(params.data, 'eqSize')
              }
            }
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerType'),
          colId: 'eqType',
          field: 'eqType',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: false,
            tag: 'span',
            attrs: {
              classFunc: (params) => {
                return ContainerUtil.containerPushDataStyleFunction(params.data, 'eqType')
              }
            }
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          colId: 'containerNo',
          field: 'containerNo',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.dgContainerEditable,
            tag: 'cargo-cell-input', // this.dgContainerEditable ? 'el-input' : 'span',
            attrs: {
              isUppercase: true,
              isTrim: true,
              classFunc: (params) => {
                return this.containerNbrStyleFunction(params.data)
              }
            },
            valueChanged: p => {
              const check = JobUtils.checkCNoHandler(this.job, p.originalValue)
              if (check) {
                p.data[p.colId] = p.originalValue
                return
              }
              this.onCellChange(p)
            },
            multiplePaste: { isUppercase: true, isTrim: true, maxLength: 11 }
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerWeight'),
          colId: 'containerWeight',
          field: 'containerWeight',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.dgContainerEditable,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              classFunc: (params) => {
                return ContainerUtil.containerPushDataStyleFunction(params.data, 'containerWeight')
              },
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2, true))
              },
              checkInput: (val) => {
                // 空值允许删除
                if (!val) return true
                return isNumber(val)
              }
            },
            valueChanged: p => {
              this.onCellChange(p)
            },
            multiplePaste: { isNumber: true, precision: 2 }
          }
        },
        {
          headerName: this.$t('SeaExport.SealNo'),
          colId: 'sealNo',
          field: 'sealNo',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.dgContainerEditable,
            tag: 'cargo-cell-input',
            attrs: {
              isUppercase: true,
              isTrim: true,
              classFunc: (params) => {
                return this.sealNoStyleFunction(params.data)
              }
            },
            valueChanged: p => {
              this.onCellChange(p)
            },
            multiplePaste: {}
          }
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          colId: 'quantity',
          field: 'quantity',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.dgContainerEditable,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              classFunc: (params) => {
                return ContainerUtil.containerPushDataStyleFunction(params.data, 'quantity')
              },
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 0, true))
              },
              checkInput: (val) => {
                // 空值允许删除
                if (!val) return true
                return isNumber(val)
              }
            },
            valueChanged: p => {
              this.onCellChange(p)
            },
            multiplePaste: { isNumber: true, precision: 0 }
          }
        },
        {
          headerName: this.$t('SeaExport.GrossWeight'),
          colId: 'weight',
          field: 'weight',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.dgContainerEditable,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              classFunc: (params) => {
                return ContainerUtil.containerPushDataStyleFunction(params.data, 'weight')
              },
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3, true))
              },
              checkInput: (val) => {
                // 空值允许删除
                if (!val) return true
                return isNumber(val)
              }
            },
            valueChanged: p => {
              this.onCellChange(p)
            },
            multiplePaste: { isNumber: true, precision: 3 }
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          colId: 'cubage',
          field: 'cubage',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.dgContainerEditable,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              classFunc: (params) => {
                return ContainerUtil.containerPushDataStyleFunction(params.data, 'cubage')
              },
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3, true))
              },
              checkInput: (val) => {
                // 空值允许删除
                if (!val) return true
                return isNumber(val)
              }
            },
            valueChanged: p => {
              this.onCellChange(p)
            },
            multiplePaste: { isNumber: true, precision: 3 }
          }
        },
        {
          headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
          colId: 'cargoName',
          field: 'cargoName',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.dgContainerEditable,
            tag: 'cargo-cell-input',
            attrs: {
              isUppercase: this.isUppercaseByConfig
            },
            valueChanged: p => {
              this.onCellChange(p)
            },
            multiplePaste: { isUppercase: this.isUppercaseByConfig }
          }
        },
        {
          headerName: this.$t('SeaExport.Marks'),
          colId: 'mark',
          field: 'mark',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.dgContainerEditable,
            tag: 'cargo-cell-input',
            attrs: {
              isUppercase: this.isUppercaseByConfig
            },
            valueChanged: p => {
              this.onCellChange(p)
            },
            multiplePaste: { isUppercase: this.isUppercaseByConfig }
          }
        },
        {
          headerName: this.$t('SeaExport.Soc'),
          colId: 'soc',
          field: 'soc',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.dgContainerEditable,
            tag: 'el-checkbox',
            valueChanged: p => {
              this.onCellChange(p)
            }
          }
        },
        {
          headerName: this.$t('SeaExport.Inspection'),
          colId: 'inSpected',
          field: 'inSpected',
          width: 100,
          cellRenderer: (params) => {
            return this.subInSpectedLabelFunc(params.data)
          }
        },
        {
          headerName: 'HSCODE',
          colId: 'hsCode',
          field: 'hsCode',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.dgContainerEditable,
            tag: 'cargo-cell-input',
            valueChanged: p => {
              this.onCellChange(p)
            },
            multiplePaste: {}
          }
        },
        {
          headerName: this.$t('SeaExport.LoadingPort'),
          colId: 'loadingPort',
          field: 'loadingPort',
          hide: true,
          width: 100
        },
        {
          headerName: this.$t('SeaExport.PortOfDestination'),
          colId: 'destinationPort',
          field: 'destinationPort',
          hide: true,
          width: 100
        },
        {
          headerName: this.$t('SeaExport.TheArrivalOfPacketsSent'),
          colId: 'transportMessageDate',
          field: 'transportMessageDate',
          hide: true,
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CustomsClearanceInfo'),
          colId: 'customReleaseDate',
          field: 'customReleaseDate',
          hide: true,
          width: 120,
          cellRenderer: (params) => {
            return this.releaseDateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.WharfReleaseInfo'),
          colId: 'wharfReleaseDate',
          field: 'wharfReleaseDate',
          hide: true,
          width: 120,
          cellRenderer: (params) => {
            return this.releaseDateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerAscription'),
          colId: 'boxAscription',
          field: 'boxAscription',
          width: 120,
          cellRenderer: params => {
            switch (params.value) {
              case 1:
                return this.$t('RailwayExport.CustomersOwnContainer')
              case 2:
                return this.$t('RailwayExport.CompanyOwnedContainer')
              case 3:
                return this.$t('RailwayExport.RentalContainer')
              default:
                return 'N'
            }
          }
        },
        {
          headerName: this.$t('SeaExport.BoxOwner'),
          colId: 'boxOwner',
          field: 'boxOwner',
          width: 120,
          cellRenderer: params => {
            if (params.value > 0) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            } else {
              return 'N'
            }
          }
        },
        {
          headerName: this.$t('SeaExport.plateApproachDate'),
          colId: 'plateApproachDate',
          field: 'plateApproachDate',
          hide: true,
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.platePlayDate'),
          colId: 'platePlayDate',
          field: 'platePlayDate',
          hide: true,
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CarNumber'),
          colId: 'carNumber',
          field: 'carNumber',
          hide: true,
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.dgContainerEditable,
            tag: 'cargo-cell-input',
            valueChanged: p => {
              this.onCellChange(p)
            },
            multiplePaste: {}
          }
        },
        {
          headerName: this.$t('SeaExport.Remarks'),
          colId: 'remark',
          field: 'remark',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.dgContainerEditable,
            tag: 'cargo-cell-input',
            valueChanged: p => {
              this.onCellChange(p)
            },
            multiplePaste: {}
          }
        },
        {
          headerName: this.$t('SeaExport.BoxController'),
          colId: 'boxController',
          field: 'boxController',
          hide: true,
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.dgContainerEditable,
            tag: 'cargo-cell-input',
            valueChanged: p => {
              this.onCellChange(p)
            },
            multiplePaste: {}
          }
        }
      ]
      if (this.job.lob === SystemConstants.RE.code || this.job.lob === SystemConstants.RI.code) {
        columnDefs.push(
          {
            headerName: this.$t('SeaExport.ApproachDate'),
            colId: 'approachDate',
            field: 'approachDate',
            width: 120,
            hide: true,
            editable: this.dgContainerEditable,
            cellEditor: 'CargoAgGridDateTimeEditor',
            cellEditorParams: {
              props: {
                type: 'datetime',
                format: 'yyyy-MM-dd HH:mm:ss',
                valueFormat: 'yyyy-MM-dd HH:mm:ss',
                editable: false
              }
            },
            onCellValueChanged: p => this.onCellChange(p),
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.PlayDate'),
            colId: 'playDate',
            field: 'playDate',
            width: 120,
            hide: true,
            editable: this.dgContainerEditable,
            cellEditor: 'CargoAgGridDateTimeEditor',
            cellEditorParams: {
              props: {
                type: 'datetime',
                format: 'yyyy-MM-dd HH:mm:ss',
                valueFormat: 'yyyy-MM-dd HH:mm:ss',
                editable: false
              }
            },
            onCellValueChanged: p => this.onCellChange(p),
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.DateOfReturningTheContainer'),
            colId: 'returnBoxTime',
            field: 'returnBoxTime',
            width: 120,
            editable: this.dgContainerEditable && !this.relatedRailwayContainers,
            cellEditor: 'CargoAgGridDateTimeEditor',
            cellEditorParams: {
              props: {
                type: 'date',
                format: 'yyyy-MM-dd',
                valueFormat: 'yyyy-MM-dd',
                editable: false
              }
            },
            onCellValueChanged: p => this.onCellChange(p),
            cellRenderer: params => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.PlateNumber'),
            colId: 'plateNumber',
            field: 'plateNumber',
            hide: true,
            width: 120,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: this.dgContainerEditable,
              tag: 'cargo-cell-input',
              valueChanged: p => {
                this.onCellChange(p)
              },
              multiplePaste: {}
            }
          },
          {
            headerName: this.$t('Warehouse.Driver'),
            colId: 'driverName',
            field: 'driverName',
            hide: true,
            width: 100,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: this.dgContainerEditable,
              tag: 'cargo-cell-input',
              valueChanged: p => {
                this.onCellChange(p)
              },
              multiplePaste: {}
            }
          }
        )
      } else {
        columnDefs.push(
          {
            headerName: this.$t('SeaExport.ApproachDate'),
            colId: 'approachDate',
            field: 'approachDate',
            width: 120,
            hide: true,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.PlayDate'),
            colId: 'playDate',
            field: 'playDate',
            width: 120,
            hide: true,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.DateOfReturningTheContainer'),
            colId: 'returnBoxTime',
            field: 'returnBoxTime',
            width: 120,
            cellRenderer: params => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.PlateNumber'),
            colId: 'plateNumber',
            field: 'plateNumber',
            hide: true,
            width: 120
          }
        )
      }
      return columnDefs
    }
  },
  methods: {
    onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      this.job = row
      this.jobChanged()
      this.btnshowAWindow = (StrUtils.isEmpty(this.job.relatedJob) && !StrUtils.isEmpty(this.job.trustFromJob)) ||
        (StrUtils.isEmpty(this.job.trustFromJob) && !StrUtils.isEmpty(this.job.relatedJob))
      this.isUppercaseByConfig = Number(this.context.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    },
    jobChanged() {
      const job = this.job
      this.jobLoadResultHandler()
      // lcl小票，通过usage关联出container
      if (job.lclMasterUuid) {
        const ctnr = []
        for (const item of job.containerUsages) {
          ctnr.push(item.container)
        }
        if (!job.containers) {
          job.containers = []
        }
        job.containers.splice(0, job.containers.length, ...ctnr)
      }
      // 组装containers.containerUsage，同job.containerUsages指向同一usage
      ContainerUtil.buildContainerUsages(this.job)
      this.containerUsages = this.job.containerUsages
      this.refreshContainerWeight()
      this.isFCL = this.job.containerLoadType === 'FCL'
      this.dgContainerEditable = this.isEdit && StrUtils.isEmpty(this.job.lclMasterUuid)
      this.relatedRailwayContainers = false
      if (this.job.railwayContainers) {
        this.relatedRailwayContainers = this.job.railwayContainers.length > 0
      }
    },
    jobLoadResultHandler() {
      // 根据箱型初始化箱子(待审核的时候不允许看到装箱信息)
      if (this.job.jobState > SystemConstants.PENDING) {
        ContainerUtil.autoJustContainerUsages(this.job, this.action)
      }
      this.selectedContainerUsage = null
      this.refreshTotal()
    },
    refreshTotal() {
      let quantity = 0
      let weight = 0
      let cubage = 0
      for (const usage of this.job.containerUsages) {
        quantity += usage.quantity
        if (!isNaN(usage.weight)) {
          weight += usage.weight
        }
        if (!isNaN(usage.cubage)) {
          cubage += usage.cubage
        }
      }
      this.lbTotalDesc.lbTotalQuantity = NumberUtils.formatNumber(quantity, 0)
      this.lbTotalDesc.lbTotalWeight = NumberUtils.formatNumber(weight, 3)
      this.lbTotalDesc.lbTotalCubage = NumberUtils.formatNumber(cubage, 3)
      this.lbTotalDesc.lblContainerDesc = ContainerUtil.getContainerDesc(this.job)
    },
    refreshContainerWeight() {
      for (const usage of this.containerUsages) {
        if (usage.container) {
          // 列显示 箱子相关信息 移至 usage
          const eqSize = EQSize.getEQSizeByCode(usage.container.eqSize)
          usage.eqSize = eqSize === null ? '' : eqSize.code
          usage.eqType = usage.container.eqType
          usage.containerNo = usage.container.containerNo
          usage.containerWeight = usage.container.containerWeight
          usage.sealNo = usage.container.sealNo
          usage.remark = usage.container.remark
          usage.approachDate = usage.container.approachDate
          usage.playDate = usage.container.playDate
          usage.loadingPort = usage.container.loadingPort
          usage.dischargingPort = usage.container.dischargingPort
          usage.destinationPort = usage.container.destinationPort
          usage.transportMessageDate = usage.container.transportMessageDate
          usage.wharfReleaseDate = usage.container.wharfReleaseDate
          usage.customReleaseDate = usage.container.customReleaseDate
          usage.containerAscription = usage.container.containerAscription
          usage.boxAscription = usage.container.boxAscription
          usage.boxOwner = usage.container.boxOwner
          usage.returnBoxTime = usage.container.returnBoxTime
          usage.plateNumber = usage.container.plateNumber
          usage.plateApproachDate = usage.container.plateApproachDate
          usage.platePlayDate = usage.container.platePlayDate
          usage.boxController = usage.container.boxController
          usage.carNumber = usage.container.carNumber
          usage.driverName = usage.container.driverName
        }
      }
    },
    containerNbrStyleFunction(usage) {
      if (usage.container) {
        if (usage && !ContainerNoHelper.checkContainerNo(usage.container.containerNo)) {
          return 'data-red'
        }
        if (usage.container !== null && DataPushCompareUtils.comparePushData(this.$t('SeaExport.ContainerNo'), usage.container.containerNo, usage.container.uuid)) {
          return 'data-blue'
        }
      }
      return ''
    },
    sealNoStyleFunction(usage) {
      if (usage.container) {
        if (usage.isReSealed) {
          return 'data-red'
        }
        if (usage.container != null && DataPushCompareUtils.comparePushData(this.$t('SeaExport.SealNo'), usage.container.sealNo, usage.container.uuid)) {
          return 'data-blue'
        }
      }
      return ''
    },
    subInSpectedLabelFunc(data) {
      if (data && data.container) {
        const isInSpected = data.container.inSpected
        return isInSpected ? this.$t('Message.Yes') : this.$t('Message.No')
      }
      return ''
    },
    /**
     * 放行信息转换
     */
    releaseDateLabelFunc(data, fieldName) {
      if (data != null) {
        const value = data[fieldName]
        if (value != null) {
          return 'Y(' + ColumnUtils.dateLabelFunc(value) + ')'
        }
      }
      return 'N'
    },
    // 组装打印参数
    getPrintData() {
      const containerUsages = this.gridApi.getSelectedRows()
      if (!containerUsages || containerUsages.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedContainerInformation'))
        return
      }
      const params = {}
      if (containerUsages.length === 1) {
        params.CONTAINER_UUID = containerUsages[0].container.uuid
        params.category = 'FCL_RE'
        params.ctx = new RailwayExportJob(this.job)
      } else {
        const uids = []
        for (const c of containerUsages) {
          if (c.container && c.container.uuid && !uids.includes(c.container.uuid)) {
            uids.push(c.container.uuid)
          }
        }
        params.CONTAINER_UUID = uids
        params.category = 'CONTAINER_LIST_RE'
        params.ctx = new RailwayExportJob(this.job)
      }
      this.$logger.log('params', params)
      return params
    },
    // 查验更改封号
    changeSealHandler() {
      if (!this.selectedContainerUsage) {
        return
      }
      this.boxNoDialog.visible = true
    },
    // 查验更改封号的回调事件
    sealCloseHandler(data) {
      const usage = this.selectedContainerUsage
      if (usage.container.sealNo !== data.sealNo) {
        usage.isReSealed = true
        usage.container.inSpected = true
      }
      usage.container.sealNo = data.sealNo
      usage.container.containerNo = data.containerNo
      usage.container.remark = data.remark
      usage.container.isDirty = true
      // 箱子信息列字段移至 usage
      usage.sealNo = data.sealNo
      usage.containerNo = data.containerNo
      usage.remark = data.remark
      this.gridApi.refreshCells({ force: true })
    },
    // 自动装箱
    autoLoadHandler() {
      ContainerUtil.autoLoadContainerUsage(this.job)
      // 设置更改标识
      for (const ctnr of this.job.containers) {
        ctnr.isDirty = true
      }
      this.refreshTotal()
    },
    // 清空装箱记录
    autoUnloadHandler() {
      const usage = this.selectedContainerUsage
      if (usage) {
        usage.container.containerNo = ''
        usage.container.sealNo = ''
        usage.weight = 0
        usage.quantity = 0
        usage.cubage = 0
        usage.hsCode = ''
        usage.container.cargoName = ''
        usage.cargoName = ''
        // 箱子信息列字段移至 usage
        usage.containerNo = ''
        usage.sealNo = ''
        usage.container.isDirty = true
        usage.isDirty = true
        usage.boxController = ''
        usage.carNumber = ''
        usage.container.boxController = ''
        usage.container.carNumber = ''
      }
      this.gridApi.refreshCells({ force: true })
      this.refreshTotal()
    },
    // 删除装箱记录
    deleteContainerHandler() {
      const items = this.gridApi.getSelectedRows()
      for (const usage of items) {
        //  记录删除的 箱子uuid  此处记录到job 字段属性上
        if (!StrUtils.isEmpty(usage.uuid)) {
          if (!this.job.delContainerUuids) {
            this.job.delContainerUuids = []
          }
          this.job.delContainerUuids.push(usage.containerUuid)
        }
        const index = this.containerUsages.findIndex(p => p === usage)
        this.containerUsages.splice(index, 1)
      }
      this.refreshTotal()
    },
    // 模板下载
    downTemplateBtn_clickHandler() {
      const fileName = 'ContainerUsageImportTemplate(铁路).xls'
      const folderName = 'booking'
      ExportUtils.downloadTemplateFile(fileName, folderName)
    },
    beforeUploadUsage(file) {
      var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    // excel导入
    importExcelEventHandler(item) {
      const usages = lodash.cloneDeep(this.job.containerUsages)
      // 避免循环引用
      for (const usage of usages) {
        delete usage.container.containerUsage
      }
      const jobObj = { job: { lob: this.job.lob }, seaEQ: this.job.seaEQ, containerUsages: usages }
      const params = {
        file: item.file,
        job: JSON.stringify(jobObj),
        jobUuid: this.job.uuid,
        jobNo: this.job.jobNo
      }
      importExcelData(params).then(response => {
        if (response.data == null || response.data === '') {
          this.$message.warning(this.$t('SeaExport.FileContentWrong'))
        } else {
          this.uploadSuccessUsage(response.data)
        }
      })
    },
    // excel导入后的数据处理
    uploadSuccessUsage(data) {
      if (!data && !this.job) {
        this.$message.warning(this.$t('SeaExport.ImportFailedContactAdministrator'))
        return
      }
      const usageCompare = []
      for (const usage of this.job.containerUsages) {
        const oldContainer = usage.container
        for (const newUsage of data.containerUsages) {
          // 记录 已匹配的数据 如已参与比较不再 比对
          if (usageCompare.findIndex(p => p === newUsage) > -1) {
            continue
          }
          const newContainer = newUsage.container
          if (oldContainer.eqSize === newContainer.eqSize && oldContainer.eqType === newContainer.eqType) {
            oldContainer.containerNo = newContainer.containerNo
            oldContainer.sealNo = newContainer.sealNo
            oldContainer.containerWeight = newContainer.containerWeight
            oldContainer.remark = newContainer.remark
            oldContainer.cargoName = newContainer.cargoName
            oldContainer.isDirty = true
            oldContainer.boxController = newContainer.boxController
            oldContainer.carNumber = newContainer.carNumber
            oldContainer.plateNumber = newContainer.plateNumber
            oldContainer.driverName = newContainer.driverName
            usage.containerNo = newContainer.containerNo
            usage.containerWeight = newContainer.containerWeight
            usage.sealNo = newContainer.sealNo
            usage.remark = newContainer.remark
            usage.containerWeight = newContainer.containerWeight
            usage.cargoName = newContainer.cargoName
            usage.quantity = newUsage.quantity
            usage.weight = newUsage.weight
            usage.cubage = newUsage.cubage
            usage.hsCode = newUsage.hsCode
            usage.soc = newUsage.soc
            usage.isDirty = true
            usage.boxController = newContainer.boxController
            usage.carNumber = newContainer.carNumber
            usage.plateNumber = newContainer.plateNumber
            usage.driverName = newContainer.driverName
            usageCompare.push(newUsage)
            break
          }
        }
      }
      this.gridApi.refreshCells({ force: true })
    },
    /**
		 * 调箱
		 */
    callContainerEvent() {
      if (this.job.jobState === 0) {
        this.callContainerDialog.visible = true
      } else {
        this.$message.info(this.$t('RailwayExport.CurrentBeenSubmittedCannotOperate'))
      }
    },
    /**
		 * 买箱
		 */
    buyContainerEvent() {
      this.boxOperationDialog.title = BoxTubeConstants.BUYING_BOXES.chineseName
      this.boxOperationDialog.orderType = BoxTubeConstants.BUYING_BOXES.code
      this.boxOperationDialog.visible = true
    },
    /**
		 * 租箱
		 */
    rentContainerEvent() {
      this.boxOperationDialog.title = BoxTubeConstants.RENT_BOX.chineseName
      this.boxOperationDialog.orderType = BoxTubeConstants.RENT_BOX.code
      this.boxOperationDialog.visible = true
    },
    /**
		 * 清理调箱
		 */
    clearContainerEvent() {
      if (this.job.jobState === 0) {
        this.$confirm('确定执行此操作吗？', this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning',
          closeOnClickModal: false
        }).then(() => {
          const list = this.getSelectBox()
          if (list) {
            clearContainer(list, this.job.uuid).then(res => {
              const num = res.data
              if (num === -1) {
                this.$message.info(this.$t('RailwayExport.CostNotConfiguredPleaseCheck'))
              } else if (num === -2) {
                this.$message.info(this.$t('RailwayExport.CostAuditedOrInvoicedCheck'))
              } else if (num > 0) {
                this.$message.success(this.$t('RailwayExport.CleaningCompletedSuccessfulCleaningNumber') + num)
                this.reload()
              }
            })
          }
        }).catch(() => { })
      } else {
        this.$message.info(this.$t('RailwayExport.CurrentBeenSubmittedCannotOperate'))
      }
    },
    getSelectBox() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.info(this.$t('RailwayExport.PleaseBoxesYouWantProcess'))
        return
      }
      const result = []
      let text = ''
      let t = false
      for (const item of rows) {
        const c = item.container
        if (c && c.returnBoxTime) {
          if (text) {
            text += ','
          }
          text += c.containerNo
        }
        if (c.boxAscription === 0) {
          t = true
        }
        result.push(c.uuid)
      }
      if (text) {
        this.$message.info(this.$t('RailwayExport.BoxReturnedCannotContinueOperate', [text]))
        return null
      }
      if (t) {
        this.$message.info(this.$t('RailwayExport.ContainsContainerDataPleaseCheck'))
        return null
      }
      return result
    },
    reload() {
      this.job.containerUsages = ''
      this.job.containers = ''
      this.job.railwayContainers = ''
      const loading = getLoading()
      this.context.loading = true
      new RailwayExportJob(this.job).loadJobRelated({
        containerUsages: true,
        containers: true,
        railwayContainers: true
      }).then(() => {
        this.onShow(this.job, true)
      }).finally(() => {
        loading.close()
        this.context.reloadCharge = true
        this.context.loading = false
      })
    },
    /**
		 * 还箱
		 */
    returnBoxEvent() {
      const list = this.getSelectBox()
      if (list) {
        this.returnBoxDialog.selectList = list
        this.returnBoxDialog.visible = true
      }
    },
    // 查看关联业务
    showAWindowClickHandler() {
      const params = {
        trustFromJobNo: this.job.trustFromJob,
        relatedJobNo: this.job.relatedJob
      }
      // 调用api
      queryAssociatedBusiness(params).then(res => {
        this.queryWindowResultHandler(res.data)
      })
    },
    queryWindowResultHandler(data) {
      this.associatedBusinessDialog.aData = data
      this.associatedBusinessDialog.visible = true
    },
    // 刷新
    refresh() {
      if (this.job && !StrUtils.isEmpty(this.job.uuid)) {
        this.jobChanged()
      }
    },
    // 行选择事件
    itemClickHandler(event) {
      if (!event.data) {
        return
      }
      this.selectedContainerUsage = event.data
    },
    onCellFocused(event) {
      if (this.gridOptions.api && event.column) {
        this.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.selectedContainerUsage = node.data
          }
        })
      }
    },
    // 列编辑修改事件 (gridEditSaveHandler)
    onCellChange(params) {
      const _job = this.job
      const usage = params.data
      if (!usage) {
        return
      }
      // 列编辑时 usage.container 没了，所以加了如下方法重新赋值
      if (usage && !usage.container && this.job.containers && this.job.containers.length > 0) {
        for (const container of this.job.containers) {
          if (StrUtils.isEmpty(container.uuid)) continue
          if (usage.containerUuid === container.uuid) {
            usage.container = container
          }
          if (container.containerUsage) {
            for (let oldUsage of container.containerUsage) {
              if (usage.uuid === oldUsage.uuid) {
                oldUsage = usage
              }
            }
          }
        }
      }
      usage.container.isDirty = true
      const key = params.field || params.colDef.colId
      switch (key) {
        case 'containerNo':
          usage.container.containerNo = usage.containerNo
          break
        case 'sealNo':
          usage.container.sealNo = usage.sealNo
          break
        case 'containerWeight':
          // 箱重处理四舍五入 入库（控件只做了前端显示处理）
          if (usage.containerWeight) {
            usage.containerWeight = roundHalfUp(usage.containerWeight, 2)
            usage.container.containerWeight = usage.containerWeight
          } else {
            usage.containerWeight = 0
            usage.container.containerWeight = usage.containerWeight
          }
          break
        case 'containerAscription':
          usage.container.containerAscription = usage.containerAscription
          break
        case 'cargoName':
          usage.container.cargoName = usage.cargoName
          break
        case 'remark':
          usage.container.remark = usage.remark
          break
        case 'boxController':
          usage.container.boxController = usage.boxController
          break
        case 'carNumber':
          usage.container.carNumber = usage.carNumber
          break
        case 'mark':
          usage.container.mark = usage.mark
          break
        case 'quantity':
          // 用删除的方式 内容是空 保存null 会报错
          if (!usage.quantity) {
            usage.quantity = 0
          }
          // h5 不需要 quantityChange(usage, event);
          if (_job && _job.lob === SystemConstants.SE.code) {
            this.updateJobActualQWC()
            this.refreshQWC()
            if (usage.container) {
              usage.container.quantity = usage.quantity
            }
          }
          usage.isDirty = true
          break
        case 'weight':
          if (!usage.weight) {
            usage.weight = 0
          }
          // h5 不需要  weightChange(usage, event);
          if (_job && _job.lob === SystemConstants.SE.code) {
            this.updateJobActualQWC()
            this.refreshQWC()
            if (usage.container) {
              usage.container.weight = usage.weight
            }
          }
          break
        case 'cubage':
          if (!usage.cubage) {
            usage.cubage = 0
          }
          // h5 不需要  cubageChange(usage, event);
          if (_job && _job.lob === SystemConstants.SE.code) {
            this.updateJobActualQWC()
            this.refreshQWC()
            if (usage.container) {
              usage.container.cubage = usage.cubage
            }
          }
          break
        case 'driverName':
          usage.container.driverName = usage.driverName
          break
        case 'plateNumber':
          usage.container.plateNumber = usage.plateNumber
          break
        case 'returnBoxTime':
          usage.container.returnBoxTime = usage.returnBoxTime
          break
        case 'playDate':
          usage.container.playDate = usage.playDate
          break
        case 'approachDate':
          usage.container.approachDate = usage.approachDate
          break
        default:
          break
      }
    },
    updateJobActualQWC() {
      ContainerUtil.refContainerUsageQwc(this.job, 1)
    },
    /**
     * 计算件毛体总数
     */
    refreshQWC() {
      let quantity = 0
      let weight = 0
      let cubage = 0
      for (const usage of this.job.containerUsages) {
        quantity += usage.quantity
        if (!isNaN(usage.weight)) {
          weight += usage.weight
        }
        if (!isNaN(usage.cubage)) {
          cubage += usage.cubage
        }
      }
      this.lbTotalDesc.lbTotalQuantity = NumberUtils.formatNumber(quantity, 0)
      this.lbTotalDesc.lbTotalWeight = NumberUtils.formatNumber(weight, 3)
      this.lbTotalDesc.lbTotalCubage = NumberUtils.formatNumber(cubage, 3)
    },
    endTabHandler() {
      this.fillModel()
    },
    fillModel() {
      // CARGO-7908
      const expression = Number(this.context.config.get('ContainerUpdateJobQCW'))
      if (expression === 3 && this.isTabBasic) {
        ContainerUtil.refContainerUsageQwc(this.job, 3)
      }
    },
    getSubmitData() {
      this.validate()
      this.fillModel()
      // 装箱件毛体 可能是从基本页签同步而来 没有触发cellChange 方法，同步箱子上的件毛体
      for (const usage of this.containerUsages) {
        if (usage.container) {
          usage.container.quantity = usage.quantity
          usage.container.weight = usage.weight
          usage.container.cubage = usage.cubage
        }
      }
      // 过滤 isDirty = true 提交至后端保存 待全局测试
      const job = { ...this.job }
      return {
        job, // 未打开过时 件毛体同步数据需要保存
        containers: this.job.containers.filter(p => p.isDirty === true),
        delContainerUuids: this.job.delContainerUuids // 删除的箱子uuid
      }
    },
    /**
     * 验证
     */
    validate() {
      if (!this.job || !this.job.containerUsages || !this.isEdit) {
        return true
      }
      const msg = ContainerUtil.validateContainerUsage(this.job)
      if (msg) {
        throw new TabError(msg, 'tabContainer')
      }
      return true
    }
  }
}
</script>

<style scoped lang='scss'>
#app .main-content .section {
  .data-red ::v-deep {
    color: #ff0000;
    input.el-input__inner {
      color: #ff0000;
    }
  }
  .data-blue ::v-deep {
    color: #0000ff;
    input.el-input__inner {
      color: #0000ff;
    }
  }
}
</style>
